import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

// The Living Cover's two small lines, the same on /canvas and the home page (owner 2026-10-20: "make the title of the
// first screenshot the same as this too").

/** The apps it's for, each in its own colour (owner 2026-10-19: Spotify in green, YouTube as important as Spotify). */
export function CanvasAppsLine({ className }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <p className={cn('text-[15px] font-bold tracking-[-0.01em] sm:text-[17px]', className)} data-testid="qt-for-spotify">
      {/* The word, never the logo: Spotify keeps its logo for its own "Listen on Spotify" links. */}
      <span className="text-[#1DB954]" translate="no">Spotify</span> <span translate="no">Canvas</span>
      <span className="text-muted-foreground"> · </span>
      <span className="text-[#FF0033]" translate="no">YouTube</span> <span translate="no">Shorts</span>
      <span className="font-semibold text-muted-foreground"> · {t('qt.tools.canvas.alsoFor')}</span>
    </p>
  );
}

/** Under the title, in small letters (owner 2026-10-20: "put the 'by FaceShot-ChopShop' in small letters"). */
export function CanvasByline({ className }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <p className={cn('text-[13.5px] text-muted-foreground sm:text-[14.5px]', className)} data-testid="canvas-byline">
      <span className="font-semibold text-foreground/80" translate="no">{t('qt.tools.canvas.by')}</span>
    </p>
  );
}
